import React from 'react';

const Error = ({mensaje}) => {
    return ( 
        <div className='d-flex justify-content-center'>
            <p className='text-center text-uppercase error'>{mensaje}</p>
        </div>
     );
}
 
export default Error;